import React from 'react';
import { useGetFeatureAccess } from 'v2/hooks/useGetFeatureAccess';

import Wallet from './component';

function WalletWithHook() {
  const { data: featureAccessData, refetch: refetchFeatureAccessData } = useGetFeatureAccess();

  return (
    <Wallet
      anticipationStatus={featureAccessData?.anticipation}
      transferStatus={featureAccessData?.transfer}
      refetchFeatureAccessData={refetchFeatureAccessData}
    />
  );
}

export default WalletWithHook;
